export default __webpack_public_path__ + "static/media/img-stats-graf-04.2d9a5097.jpg";